import type {
  Appointment,
  Consultation,
  Patient,
  User,
} from "../UserContext.types";

export const STORAGE_KEYS = {
  USER: "user",
  TOKEN: "token",
  PATIENTS: "doctorPatients",
  APPOINTMENTS: "doctorAppointments",
  CONSULTATIONS: "doctorConsultations",
} as const;

export const DEFAULT_PATIENTS: Patient[] = [];

export const DEFAULT_APPOINTMENTS: Appointment[] =
  [];

export const DEFAULT_CONSULTATIONS: Consultation[] =
  [];

export const loadFromLocalStorage = <T,>(
  key: string,
  defaultValue: T
): T => {
        if (
          key === STORAGE_KEYS.PATIENTS ||
          key === STORAGE_KEYS.APPOINTMENTS ||
          key === STORAGE_KEYS.CONSULTATIONS
        ) return defaultValue;

  try {
    const storedValue = localStorage.getItem(key);

    if (!storedValue) {
      return defaultValue;
    }

    return JSON.parse(storedValue) as T;
  } catch {
    return defaultValue;
  }

      };

export const saveToLocalStorage = <T,>(
  key: string,
  value: T
): void => {
        if (
          key === STORAGE_KEYS.PATIENTS ||
          key === STORAGE_KEYS.APPOINTMENTS ||
          key === STORAGE_KEYS.CONSULTATIONS
        ) return;

  try {
    localStorage.setItem(
      key,
      JSON.stringify(value)
    );
  } catch {
    // Temporary local-storage persistence.
    // Replace with API persistence when backend is ready.
  }

      };

export const removeFromLocalStorage = (
  key: string
): void => {
  try {
    localStorage.removeItem(key);
  } catch {
    // Ignore storage errors.
  }
};

export const restoreSession = (): {
  user: User | null;
  token: string | null;
} => { return { user: null, token: null }; };
